import { useEffect, useState } from 'react';
import { UserPlus, Check, X, KeyRound } from 'lucide-react';
import api from '../api';

// Usuarios de la empresa: el administrador crea supervisores y usuarios de consulta.
// No se borran: se desactivan (el historial queda con su nombre).

const DESCRIPCION_ROL = {
  admin: 'Todo: campañas, agente, troncal, facturación y usuarios.',
  supervisor: 'Crea, carga bases, lanza y pausa campañas. Ve llamadas, grabaciones e informes. No ve facturación ni cambia el agente.',
  consulta: 'Solo ve informes, llamadas y grabaciones.',
};

const inp = { width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 9, color: 'var(--text)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };
const btn = { padding: '10px 20px', background: 'linear-gradient(135deg,var(--accent-solid),var(--accent-2))', border: 'none', color: '#fff', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 };
const btnSec = { padding: '6px 12px', background: 'transparent', border: '1px solid var(--surface-2)', color: 'var(--text-2)', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 };

function fecha(iso) {
  if (!iso) return 'Nunca';
  return new Date(iso.endsWith('Z') ? iso : iso + 'Z').toLocaleString('es-CO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [claveDe, setClaveDe] = useState(null);
  const [clave, setClave] = useState('');

  const cargar = () => api.get('/usuarios').then(r => { setUsuarios(r.data.usuarios); setRoles(r.data.roles); })
    .catch(e => setMsg({ ok: false, txt: e.response?.data?.detail || 'No se pudieron cargar los usuarios' }))
    .finally(() => setCargando(false));
  useEffect(() => { cargar(); }, []);

  const crear = async () => {
    if (!form.nombre || !form.correo || !form.password) { setMsg({ ok: false, txt: 'Completa nombre, correo y contraseña' }); return; }
    if (form.password.length < 8) { setMsg({ ok: false, txt: 'La contraseña debe tener al menos 8 caracteres' }); return; }
    setGuardando(true);
    try {
      await api.post('/usuarios', form);
      setMsg({ ok: true, txt: `Usuario creado. Entrégale a ${form.nombre} su correo y contraseña; puede cambiarla en Mi cuenta.` });
      setForm(null); cargar();
    } catch (e) { setMsg({ ok: false, txt: e.response?.data?.detail || 'No se pudo crear el usuario' }); }
    setGuardando(false);
  };

  const cambiar = async (u, cambios, texto) => {
    try {
      await api.patch(`/usuarios/${u.id}`, cambios);
      setMsg({ ok: true, txt: texto }); cargar();
    } catch (e) { setMsg({ ok: false, txt: e.response?.data?.detail || 'No se pudo guardar' }); }
  };

  const guardarClave = async (u) => {
    if (clave.length < 8) { setMsg({ ok: false, txt: 'La contraseña debe tener al menos 8 caracteres' }); return; }
    await cambiar(u, { password: clave }, `Contraseña de ${u.nombre} cambiada`);
    setClaveDe(null); setClave('');
  };

  return (
    <div style={{ maxWidth: 980 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontFamily: 'Inter,sans-serif', fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Usuarios</h1>
          <p style={{ color: 'var(--text-3)', fontSize: 13, margin: 0 }}>Cada supervisor entra con su propio usuario. En Actividad queda quién lanzó o cambió cada cosa.</p>
        </div>
        {!form && <button style={btn} onClick={() => { setMsg(null); setForm({ nombre: '', correo: '', rol: 'supervisor', password: '' }); }}><UserPlus size={15} />Nuevo usuario</button>}
      </div>

      {msg && <div style={{ marginBottom: 16, padding: '10px 14px', borderRadius: 9, fontSize: 13, fontWeight: 600, background: msg.ok ? 'var(--success-soft)' : 'var(--danger-soft)', color: msg.ok ? 'var(--success)' : 'var(--danger)' }}>{msg.txt}</div>}

      {form && (
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', marginBottom: 16 }}>Nuevo usuario</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 14 }}>
            <div><label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Nombre</label>
              <input style={inp} value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} placeholder="Ej: Laura Gómez" /></div>
            <div><label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Correo (con este entra)</label>
              <input style={inp} type="email" value={form.correo} onChange={e => setForm(f => ({ ...f, correo: e.target.value }))} placeholder="laura@empresa.com" /></div>
            <div><label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Contraseña inicial (mínimo 8)</label>
              <input style={inp} type="password" autoComplete="new-password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} /></div>
          </div>
          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 8 }}>Rol</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 10 }}>
              {roles.map(r => (
                <button key={r.valor} onClick={() => setForm(f => ({ ...f, rol: r.valor }))} style={{ textAlign: 'left', padding: '12px 14px', borderRadius: 10, cursor: 'pointer', background: form.rol === r.valor ? 'color-mix(in srgb, var(--accent-solid) 14%, transparent)' : 'var(--surface-3)', border: `1px solid ${form.rol === r.valor ? 'var(--accent-solid)' : 'var(--surface)'}` }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>{r.etiqueta}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 4, lineHeight: 1.45 }}>{DESCRIPCION_ROL[r.valor]}</div>
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button style={btn} disabled={guardando} onClick={crear}><Check size={15} />{guardando ? 'Creando...' : 'Crear usuario'}</button>
            <button style={btnSec} onClick={() => setForm(null)}>Cancelar</button>
          </div>
        </div>
      )}

      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, overflow: 'hidden' }}>
        {cargando && <div style={{ padding: 24, color: 'var(--text-3)', fontSize: 13 }}>Cargando...</div>}
        {!cargando && usuarios.map((u, i) => (
          <div key={u.id || 'principal'} style={{ padding: '14px 20px', borderBottom: i < usuarios.length - 1 ? '1px solid var(--surface-3)' : 'none', opacity: u.activo ? 1 : 0.55 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, background: 'color-mix(in srgb, var(--accent-solid) 15%, transparent)', color: 'var(--accent-solid)', flexShrink: 0 }}>
                {(u.nombre || u.correo || '?').trim().charAt(0).toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{u.nombre}{!u.activo && <span style={{ color: 'var(--danger)', fontWeight: 600, marginLeft: 8, fontSize: 11 }}>Desactivado</span>}</div>
                <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>{u.correo}</div>
              </div>
              {u.principal ? (
                <span style={{ fontSize: 12, color: 'var(--text-2)' }}>{u.rol_etiqueta}</span>
              ) : (
                <>
                  <select value={u.rol} onChange={e => cambiar(u, { rol: e.target.value }, `${u.nombre} ahora es ${roles.find(r => r.valor === e.target.value)?.etiqueta}`)}
                    style={{ ...inp, width: 'auto', padding: '6px 10px', fontSize: 12 }}>
                    {roles.map(r => <option key={r.valor} value={r.valor}>{r.etiqueta}</option>)}
                  </select>
                  <span style={{ fontSize: 11, color: 'var(--text-3)', minWidth: 120 }}>Último ingreso: {fecha(u.ultimo_ingreso)}</span>
                  <button style={btnSec} onClick={() => { setClaveDe(claveDe === u.id ? null : u.id); setClave(''); }}><KeyRound size={13} />Contraseña</button>
                  <button style={btnSec} onClick={() => cambiar(u, { activo: !u.activo }, u.activo ? `${u.nombre} ya no puede entrar` : `${u.nombre} puede entrar de nuevo`)}>
                    {u.activo ? <><X size={13} />Desactivar</> : <><Check size={13} />Activar</>}
                  </button>
                </>
              )}
            </div>
            {claveDe && claveDe === u.id && (
              <div style={{ display: 'flex', gap: 10, marginTop: 12, marginLeft: 50, flexWrap: 'wrap' }}>
                <input style={{ ...inp, maxWidth: 260 }} type="password" autoComplete="new-password" placeholder="Nueva contraseña (mínimo 8)" value={clave} onChange={e => setClave(e.target.value)} />
                <button style={btn} onClick={() => guardarClave(u)}>Guardar</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
